<div [class]="'search-box ' + tallClass">
  <input type="text" (change)="search($event.target.value, false)" #searchList [placeholder]="placeholder" >
  <button mat-raised-button (click)="search(searchList.value, true)" color="primary">
    <fa-icon icon="search"></fa-icon>
  </button>
</div>
